import React from "react";
import { Date, Text } from "@common/formx";
import locale from "@bonliva-crm/locale";
import { FieldProps as FieldPropsBase } from "@consultants/ConsultantContract/DynamicFieldsGroup";
import yup from "yup";
import { moment } from "@bonliva-crm/common";
import { SubVersionFormStore, FormData } from "./SubVersionFormStore";
import ConsultantSelector from "@containers/VirtualSelector/ConsultantSelector/ConsultantSelector";

type FieldProps = FieldPropsBase<FormData, SubVersionFormStore>;

const field = ({
  name,
  order = 0,
  show = () => true,
  schema,
  isGroup = false,
  gridProps,
  xs = 4,
  md,
  render
}: FieldProps) => ({ name, order, show, schema, isGroup, gridProps, xs, md, render });

export const consultant: FieldProps = field({
  name: "consultantId",
  xs: 12,
  schema: yup.string().nullable(true).required(locale.Consultant),
  render: (form, { store }) => {
    const ConsultantId = form.getValue("consultantId");
    const value = ConsultantId
      ? {
          label: "",
          value: ConsultantId
        }
      : null;
    return (
      <ConsultantSelector
        clearable
        error={form.getError("consultantId")}
        fullWidth
        required
        disabled={store.isEdit}
        onChange={store.setConsultant}
        value={value as any}
      />
    );
  }
});

export const startDate: FieldProps = field({
  name: "startDate",
  xs: 4,
  schema: yup.string().nullable(true).required(" "),
  render: (form, { store }) => {
    const label = locale.StartDate;
    return (
      <Date
        utc
        disabled={store.alreadyUploadedDocument}
        key={"StartDate"}
        DatePickerProps={{
          startDate: moment().toDate(),
          shouldCloseOnSelect: true,
          placeholder: label
        }}
        name="startDate"
        label={label}
      />
    );
  }
});

export const endDate: FieldProps = field({
  name: "endDate",
  xs: 4,
  schema: yup.string().nullable(true).required(" "),
  render: (form, { store }) => {
    const label = locale.EndDate;
    return (
      <Date
        utc
        key={"endDate"}
        disabled={store.alreadyUploadedDocument}
        DatePickerProps={{
          startDate: moment().toDate(),
          shouldCloseOnSelect: true,
          placeholder: label
        }}
        name="endDate"
        label={locale.EndDate}
      />
    );
  }
});

export const basicPrice: FieldProps = field({
  name: "basicPrice",
  xs: 8,
  schema: yup
    .number()
    .positive()
    .nullable(true)
    .required(locale.fieldIsMandatory(locale.Price)),
  render: (form, { store }) => {
    return (
      <Text
        name={`basicPrice`}
        disabled={store.alreadyUploadedDocument}
        label={locale.Price}
        TextFieldProps={{
          inputMode: "numeric"
        }}
      />
    );
  }
});
